export default __webpack_public_path__ + "static/media/UPE_AA.335a6a9d.svg";